<template>
    <v-card-text class="text-body-1 px-2 px-sm-3 px-md-4">
        <slot></slot>
    </v-card-text>
</template>